/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EAccessTypes } from '../../models/e-access-types';
import { ResetPasswordDto } from '../../models/reset-password-dto';

export interface UserResetPasswordWithLoginOrMail$Params {
  loginOrMail?: string;
  accessType?: EAccessTypes;
}

export function userResetPasswordWithLoginOrMail(http: HttpClient, rootUrl: string, params?: UserResetPasswordWithLoginOrMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResetPasswordDto>> {
  const rb = new RequestBuilder(rootUrl, userResetPasswordWithLoginOrMail.PATH, 'get');
  if (params) {
    rb.query('loginOrMail', params.loginOrMail, {});
    rb.query('accessType', params.accessType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResetPasswordDto>;
    })
  );
}

userResetPasswordWithLoginOrMail.PATH = '/v1/User/ResetPasswordWithLoginOrMail';
